import { Component, ElementRef, ViewChild, type OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { KcDataService } from '../../../kc-data.service'
import {
  type KcRealmData,
  type KcClientData,
  type KcEmailChangeViewData
} from '../../../interfaces/kc-data.interface'
import { InstantErrorStateMatcherService } from '../../../services/instant-error-state-matcher.service'
import { KcValidationService } from '../../../kc-validation.service'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { type B2CConfig } from '@inside-hub-app/customer-portal-config'

@Component({
  selector: 'customer-portal-app-revolution-email-change',
  templateUrl: './revolution-email-change.component.html'
})
export class RevolutionEmailChangeComponent implements OnInit {
  matcher = new InstantErrorStateMatcherService()
  showPassword = false
  showConfirmedPassword = false
  public showPasswordUrl = 'assets/icons/visibility_24px.svg'
  public hidePasswordUrl = 'assets/icons/visibility_off_24px.svg'
  emailRegex: string

  @ViewChild('emailChangeForm', { static: true })
  private readonly formRef: ElementRef

  public form

  public realmData: KcRealmData
  public clientData: KcClientData
  public viewData: KcEmailChangeViewData
  public submitting: boolean

  constructor (
    private readonly kcDataService: KcDataService,
    private readonly kcValidationService: KcValidationService,
    public transifexService: TransifexService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.emailRegex = this.remoteConfigService.get('regEx.emailRegEx.pattern')
    this.form = new FormGroup({
      email: new FormControl<string | null>(null, [
        Validators.maxLength(50),
        Validators.pattern(this.emailRegex)
      ]),
      password: new FormControl<string | null>(null, [
        this.kcValidationService.password
      ])
    })
  }

  ngOnInit (): void {
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.viewData = this.kcDataService.getViewData() as KcEmailChangeViewData
    // set initial values
    this.form.patchValue({
      email: this.viewData?.username
    })
  }

  public update (): void {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  public toggleShowPassword (): void {
    this.showPassword = !this.showPassword
  }
}
